import Lenis from "lenis";

let lenis = null;

export const initLenis = () => {
    lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return lenis;
};

export const scrollToId = (id) => {
    if (!document.querySelector(id)) {
        const base = window.location.pathname.startsWith("/it") ? "/it" : "/";
        window.location.href = base;
        return;
    }
    if (lenis) {
        lenis.scrollTo(id, { offset: -64, duration: 1.5 });
    } else {
        document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
};
